import { defineMessages } from 'react-intl';

export default defineMessages({
  dhlDangerousGoodsNotDefined: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type not found',
    defaultMessage: 'Select Type of Goods',
    id: 'W5S4+7',
  },
  typeOfGoods: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type',
    defaultMessage: 'Type of Goods:',
    id: 'H0DNvN',
  },
  lithiumMetalBatteriesContainedInEquipment: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium Metal Batteries Contained in Equipment',
    defaultMessage: 'Lithium Metal Batteries Contained in Equipment',
    id: 'sf3y+C',
  },
  lithiumMetalBatteriesPackedWithEquipment: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium Metal Batteries Packed with Equipment',
    defaultMessage: 'Lithium Metal Batteries Packed with Equipment',
    id: 'niVUSY',
  },
  lithiumMetalBatteriesStandAlone: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium Metal Batteries Stand-alone',
    defaultMessage: 'Lithium Metal Batteries Stand-alone',
    id: 'JLhmJX',
  },
  lithiumIonBatteriesContainedInEquipment: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium-ion Batteries Contained in Equipment',
    defaultMessage: 'Lithium-ion Batteries Contained in Equipment',
    id: 'wjooaD',
  },
  lithiumIonBatteriesPackedWithEquipment: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium-ion Batteries Packed with Equipment',
    defaultMessage: 'Lithium-ion Batteries Packed with Equipment',
    id: '1YsVKi',
  },
  lithiumIonBatteriesStandAlone: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Lithium-ion Batteries Stand-alone',
    defaultMessage: 'Lithium-ion Batteries Stand-alone',
    id: 'WFnxRj',
  },
  limitedQuantity: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Limited Quantity',
    defaultMessage: 'Limited Quantity',
    id: 'VoRen4',
  },
  smallQuantityProvision: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Small Quantity Provision',
    defaultMessage: 'Small Quantity Provision',
    id: 'LPdguX',
  },
  limitedQuantitiesCanadaOnly: {
    description: 'Other Shipping Options - DHL eComm Dangerous Goods type Limited Quantities - Canada only',
    defaultMessage: 'Limited Quantities - Canada only',
    id: '0hMkmv',
  },
});
